var path = 'ilmn-ui-components/dist/configDialog.template.html';
var html = "<div class=\"modal-body row\"> <p>{{modalOptions.message}}</p> <div class=\"form-group pull-right\"> <button type=button class=btn data-ng-click=modalOptions.close()>{{modalOptions.closeButtonText}}</button> <button class=\"btn btn-primary\" data-ng-click=modalOptions.ok();>{{modalOptions.actionButtonText}}</button> </div> </div> ";
window.angular.module('ilmn-ui-utils').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-utils/views/configDialog.template.html
// module id = 20
// module chunks = 0